"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = useAdaptiveCardsPackage;

var _useAdaptiveCardsContext = _interopRequireDefault(require("./internal/useAdaptiveCardsContext"));

function useAdaptiveCardsPackage() {
  var _useAdaptiveCardsCont = (0, _useAdaptiveCardsContext.default)(),
      adaptiveCardsPackage = _useAdaptiveCardsCont.adaptiveCardsPackage;

  return [adaptiveCardsPackage];
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJ1c2VBZGFwdGl2ZUNhcmRzUGFja2FnZSIsInVzZUFkYXB0aXZlQ2FyZHNDb250ZXh0IiwiYWRhcHRpdmVDYXJkc1BhY2thZ2UiXSwic291cmNlUm9vdCI6ImJ1bmRsZTovLy8iLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9hZGFwdGl2ZUNhcmRzL2hvb2tzL3VzZUFkYXB0aXZlQ2FyZHNQYWNrYWdlLnRzIl0sInNvdXJjZXNDb250ZW50IjpbImltcG9ydCBBZGFwdGl2ZUNhcmRzUGFja2FnZSBmcm9tICcuLi8uLi90eXBlcy9BZGFwdGl2ZUNhcmRzUGFja2FnZSc7XG5pbXBvcnQgdXNlQWRhcHRpdmVDYXJkc0NvbnRleHQgZnJvbSAnLi9pbnRlcm5hbC91c2VBZGFwdGl2ZUNhcmRzQ29udGV4dCc7XG5cbmV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHVzZUFkYXB0aXZlQ2FyZHNQYWNrYWdlKCk6IFtBZGFwdGl2ZUNhcmRzUGFja2FnZV0ge1xuICBjb25zdCB7IGFkYXB0aXZlQ2FyZHNQYWNrYWdlIH0gPSB1c2VBZGFwdGl2ZUNhcmRzQ29udGV4dCgpO1xuXG4gIHJldHVybiBbYWRhcHRpdmVDYXJkc1BhY2thZ2VdO1xufVxuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7QUFDQTs7QUFFZSxTQUFTQSx1QkFBVCxHQUEyRDtFQUN4RSw0QkFBaUMsSUFBQUMsZ0NBQUEsR0FBakM7RUFBQSxJQUFRQyxvQkFBUix5QkFBUUEsb0JBQVI7O0VBRUEsT0FBTyxDQUFDQSxvQkFBRCxDQUFQO0FBQ0QifQ==